import React from 'react';
import { useTranslation } from 'react-i18next';
import ComingSoon from './ComingSoon';

const DataExport = () => {
  const { t } = useTranslation();
  return <ComingSoon title={t('settings.menu.dataExport')} />;
};

export default DataExport;
